import { AfterViewInit, Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { AlertController, Content, LoadingController, NavController, NavParams } from 'ionic-angular';
import { ServerService } from '../../services/server-service';
import { ToastService } from '../../services/toast-service';
import moment from 'moment';
import { LoginPage } from '../login/login';
import { DatePicker, DatePickerOptions } from '@ionic-native/date-picker';
import * as Hammer from 'hammerjs';


@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
})
export class HomePage implements OnInit {

  @ViewChildren(Content) content: QueryList<Content>;
  isLoading: boolean = false;
  items: any = [];
  items1: any = [];
  todayDate: any = moment().format("YYYY-MM-DD");
  searchInput: string = '';

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private api: ServerService,
    public loadingCtrl: LoadingController,
    private toast: ToastService,
    private alertCtrl: AlertController,
    private datePicker: DatePicker) {
  }


  getEvents() {
    let object = {
      "start": this.todayDate,
      "end": this.todayDate,
      "view": "day",
    };
    // events/holidays/calendar
    // console.log("object:", object);
    this.isLoading = true;
    this.api.getEvents('/events/lite/calendar', object).then((data) => {
      this.isLoading = false;

      console.log("events:", data);

      this.items = data['items'];
      this.items1 = data['items'];


    }, (err => {
      // loading.dismiss();
      this.isLoading = false;
      console.log("error2:", JSON.stringify(err));
      console.log("error status:", err.status);
      this.handleServerError(err, "שגיאה בטעינת אירועים יש לנסות שוב");
    }));
  }




  onEventSelected(event) {
    console.log("selected event:", event);

    let loading = this.loadingCtrl.create({ content: 'טוען נתונים...' });
    loading.present();

    let object = {
      "id": event.id,
    };


    console.log("object:", object);
    this.api.sendPostParams('/events/lite/get', object).then((data) => {
      loading.dismiss();
      console.log("event data:", data);
      this.navCtrl.push('ManageEventDetailsPage', {
        item: data,
      });
    }, (err => {
      loading.dismiss();
      console.log("error2:", JSON.stringify(err));
      this.handleServerError(err, "שגיאה בטעינת אירוע יש לנסות שוב");
    }));
  }



  today() {
    this.todayDate = moment().format("YYYY-MM-DD");;
    this.getEvents();
  }

  forwardDay() {
    console.log("forwardDay");
    this.todayDate = moment(this.todayDate, "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD");
    this.getEvents();
  }

  previousDay() {
    console.log("previousDay");
    this.todayDate = moment(this.todayDate, "YYYY-MM-DD").subtract(1, 'days').format("YYYY-MM-DD");
    this.getEvents();
  }

  openDatePicker() {
    let calanderOptions: DatePickerOptions = {
      date: new Date(this.todayDate),
      mode: 'date',
      locale: 'he_IL',
      androidTheme: this.datePicker.ANDROID_THEMES.THEME_DEVICE_DEFAULT_DARK
    };
    this.datePicker.show(calanderOptions).then(
      date => {
        let selcetedDate = moment(date, "YYYY-MM-DD").format("YYYY-MM-DD");
        console.log("selected date:", selcetedDate);
        console.log('Got date: ', date);
        this.todayDate = selcetedDate;
        this.getEvents();
      },
      err => {
        console.log('Error occurred while getting date: ', err);
      }
    );
  }

  onInput(ev: any) {
    this.items = this.items1;
    let val = ev.target.value;

    if (!val) {
      return;
    }

    this.items = this.items.filter(item => {
      if (val && item.title) {
        return (item.title.toLowerCase().indexOf(val.toLowerCase()) > -1);
      }
    });
  }




  onCancel() {
    this.searchInput = '';
    this.items = this.items1;
  }

  handleServerError(error, errorText) {
    // let errorText;
    let requiresReconnect: boolean = false;
    switch (error.status) {
      case 403:
        errorText = 'התחברות פג תוקף - יש להתחבר שוב';
        requiresReconnect = true;
        break;

      default:
        // errorText = errorText;
        requiresReconnect = false;
    }

    let alertBox = this.alertCtrl.create();
    alertBox.setTitle(errorText);


    if (requiresReconnect) {
      alertBox.addButton({
        text: 'התנתקות', handler: (data: string) => {
          localStorage.removeItem("user_id");
          localStorage.removeItem("token");
          localStorage.clear();
          this.navCtrl.setRoot("LoginPage");
        }
      });
    } else {
      alertBox.addButton({
        text: 'ביטול', handler: (data: string) => {
          console.log('OK clicked: ' + data);
        }
      });
    }

    alertBox.present();
  }



  addEvent() {
    this.navCtrl.push('ManageEventDetailsPage');
  }

  onSwipe() {
    this.content.changes.subscribe(() => {
      if (this.content.length > 0) {
        const mc = new Hammer(this.content.first.getScrollElement());
        mc.get('swipe').set({ direction: Hammer.DIRECTION_HORIZONTAL, threshold: 100 });

        mc.on('swipeleft', (ev) => {
          // Handle swipe left event
          console.log('Swipe left event:', ev);
          this.previousDay();
        });

        mc.on('swiperight', (ev) => {
          // Handle swipe right event
          console.log('Swipe right event:', ev);
          this.forwardDay();
        });
      }
    });
  }

  ngOnInit(): void {
    this.getEvents();

  }


  ngAfterViewInit() {
    this.onSwipe();
  }


}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts